module.exports = __webpack_public_path__ + "img/empty_pic.b14f9276.png";